import { InputProps } from '@chakra-ui/react/input'
import { Field } from '@web/components/atoms/Field'
import { Input } from '@web/components/atoms/Input'
import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'

const MOBILE_REGEX = /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?[-.\s]?)*\d{1,4}([-.\s]?\d{1,4}){0,2}$/

const MobileField = ({ ...props }: InputProps & { label?: string }) => {
  const [isInvalid, setIsInvalid] = useState(false)
  const [value] = useDebounce(props.value, 500)

  const validateInput = () => {
    if (!value && !props.required) {
      setIsInvalid(false)
      return
    }
    setIsInvalid(!MOBILE_REGEX.test(value as string))
  }

  useEffect(() => {
    validateInput()

    // if value contains spaces or () remove them
    const mobile = value as string
    if (mobile) {
      const sanitizedValue = mobile.replace(/[\s()]/g, '')
      if (sanitizedValue !== value) {
        const event = {
          target: { value: sanitizedValue, name: props.name ?? '' },
        } as React.ChangeEvent<HTMLInputElement>
        props.onChange?.(event)
      }
    }
  }, [value])

  useEffect(() => {
    setIsInvalid(false)
  }, [props.value])

  return (
    <Field
      label={props.label}
      required={props.required}
      invalid={isInvalid}
      errorText="Enter a valid mobile phone number"
    >
      <Input {...props} onBlur={validateInput} />
    </Field>
  )
}

export default MobileField
